import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useSiteSettings } from "@/lib/SiteSettingsContext";
import { useCookieConsent } from "@/lib/cookieConsent";

const PLACEHOLDER_PATTERN = /^[A-Z]*-?[xX0]+$/i; // catches "G-XXXX", "G-TEST" still valid (TEST != all-zero), only blocks empty-looking IDs

function looksReal(id) {
    if (!id) return false;
    const trimmed = String(id).trim();
    if (!trimmed) return false;
    if (PLACEHOLDER_PATTERN.test(trimmed.replace(/-/g, ""))) return false;
    return true;
}

// Top-level tracking injector. Mounted once in PublicLayout.
// Reads IDs from site_settings via SiteSettingsContext.
// Skips injection when on /admin/*.
export default function TrackingScripts() {
    const location = useLocation();
    const { settings } = useSiteSettings();
    const { allowsTracking } = useCookieConsent();

    if (location.pathname.startsWith("/admin")) return null;
    if (!allowsTracking) return null;

    const ga = looksReal(settings.google_analytics_id)
        ? settings.google_analytics_id.trim()
        : null;
    const clarity = looksReal(settings.microsoft_clarity_id)
        ? settings.microsoft_clarity_id.trim()
        : null;
    const fbPixel = looksReal(settings.facebook_pixel_id)
        ? settings.facebook_pixel_id.trim()
        : null;
    const gsv = looksReal(settings.google_search_console_verification)
        ? settings.google_search_console_verification.trim()
        : null;

    return (
        <Helmet>
            {gsv && <meta name="google-site-verification" content={gsv} />}
            {ga && (
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${ga}`}
                ></script>
            )}
            {ga && (
                <script>{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga}');
`}</script>
            )}
            {clarity && (
                <script>{`
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "${clarity}");
`}</script>
            )}
            {fbPixel && (
                <script>{`
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${fbPixel}');
fbq('track', 'PageView');
`}</script>
            )}
        </Helmet>
    );
}
